import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileType',
    standalone: false
})
export class FileTypePipe implements PipeTransform {
    transform(value: string): string {
        if (value === 'application/pdf') {
            return 'pdf';
        }
        if (value.substr(0, value.indexOf('/')) === 'image') {
            return 'image';
        }
        if (value.substr(0, value.indexOf('/')) === 'video') {
            return 'video';
        }
        return 'any';
    }
}
